import { TextField } from '@hypeit-gmbh/hypeit-ui';
import { Grid, TextInputProps } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { DEFAULT_SPAN, TRANS_KEY, useContactPrefix } from '../Root';

type EmailPropsType = {
  span?: number;
} & TextInputProps;

export const Email: React.FC<EmailPropsType> = ({ span, ...props }) => {
  const { t } = useTranslation();
  const prefix = useContactPrefix();

  return (
    <Grid.Col span={span ?? DEFAULT_SPAN}>
      <TextField
        fieldName={`${prefix}.email`}
        label={t(`${TRANS_KEY}.EMAIL_LABEL`)}
        {...props}
      />
    </Grid.Col>
  );
};
